import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const VARIANTS = {
  primary: "bg-ink text-cream hover:bg-ink-soft",
  outline: "border border-ink/25 text-ink bg-transparent hover:border-ink hover:bg-white",
  lemon: "bg-lemon text-ink hover:bg-lemon-deep",
  mint: "bg-mint text-ink hover:bg-mint-deep",
  lavender: "bg-lavender text-ink hover:bg-lavender-deep",
};

const base =
  "group inline-flex items-center justify-center gap-2 rounded-full px-6 py-3 text-base font-bold font-body transition-[transform,background-color,box-shadow] duration-200 ease-out";

export const PillLink = ({ to, href, variant = "primary", children, arrow = false, className = "", ...rest }) => {
  const cls = `${base} ${VARIANTS[variant]} ${className}`;
  const inner = (
    <>
      {children}
      {arrow && <ArrowRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-1" aria-hidden="true" />}
    </>
  );
  if (href) {
    return (
      <a href={href} className={cls} {...rest}>
        {inner}
      </a>
    );
  }
  return (
    <Link to={to} className={cls} {...rest}>
      {inner}
    </Link>
  );
};
